import logo from "../../../assets/webp/logo.webp";
import logoWhite from "../../../assets/webp/logo-white.webp";
import { useTheme } from "@mui/material";
const Logo = () => {
  const theme = useTheme();
  return (
    <img
      loading="lazy"
      style={{ width: "100%", height: "auto", objectFit: "contain" }}
      src={theme.palette.mode === "dark" ? logoWhite : logo}
    />
  );
};

export default Logo;
